<template>
	<div class="w-100 bg-color-granite d-flex justify-center flex-column">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"		
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Welcome to RISE" /></h1>
				<span><LanguagePlaceholder default-text="Elevate your rewards with every purchase" /></span>
			</div>			
		</div>
		<v-container class="d-flex justify-center bg-color-granite">
			<v-row no-gutters align="stretch" class="bg-color-granite w-auto">
				<v-col class="ga-2 d-flex flex-column">
					<v-sheet class="d-flex flex-column">
						<div class="pa-2 bg-color-cobalt tx-color-white tx-font-bold text-center">
							<LanguagePlaceholder default-text="About RISE" />
						</div>
						<div class="pa-2 bg-color-dell-blue tx-color-white tx-font-bold text-center">
							<LanguagePlaceholder default-text="The RISE Incentive Program rewards you for purchasing eligible Dell Technologies products with competitive $-per-box rewards, multipliers, and bonuses." />
						</div>
						<div class="d-flex justify-center pa-2 bg-color-dell-blue tx-color-white">
							<v-img class="d-flex justify-center align-center" cover
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/bgAbout.png"
							>
								<div class="d-flex flex-column justify-center text-center pt-10">
									<span class="tx-font-size24 tx-font-normal">
										<LanguagePlaceholder is-html default-text="Earn up to" />
									</span>
									<span class="tx-font-size48 tx-font-bold">
										<LanguagePlaceholder is-html default-text="$15,000" />
									</span>
									<span class="tx-font-size24 tx-font-normal">
										<LanguagePlaceholder is-html default-text="per incentive period!" />
									</span>
								</div>
							</v-img>
						</div>
						<div class="px-2 pb-2 bg-color-cobalt tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-royal" @click="systemStore.routerTo('home-about-rise-partner')">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>  
						</div>
          </v-sheet>
					<v-sheet class="d-flex flex-column mt-auto" style="min-height: 350px;">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<LanguagePlaceholder default-text="Eligible Products" />
						</div>
						<div class="d-flex justify-center pa-2 bg-color-quartz tx-color-white">
							<v-img class="d-flex justify-center align-center" cover height="250px"
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/EligibleProduct.jpg"
							></v-img>
						</div>
						<div class="px-2 pb-2 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('home-eligible-products')">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>  
						</div>
					</v-sheet>
				</v-col>

				<v-col cols="6" class="ga-2 mx-2 d-flex flex-column">
					<v-sheet class="d-flex flex-column">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<LanguagePlaceholder default-text="News and Promotions" />
						</div>
						<div class="px-2 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<Carousel carousel-title="Welcome" :carousel-items="carouselOneItems"></Carousel>   
						</div>
						<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('news')">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>    
						</div>
					</v-sheet>
					<v-sheet class="d-flex flex-column">
						<v-row no-gutters align="start" class="bg-color-granite w-auto d-flex ga-2">
							<v-col class="bg-color-quartz ga-2 d-flex flex-column">
								<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
									<LanguagePlaceholder default-text="My Performance" />
								</div>
								<v-row no-gutters align="start" class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-auto d-flex ga-2 pt-1 pb-2">
									<v-col cols="8" class="ga-2 d-flex flex-column ps-4">
										<LanguagePlaceholder is-html default-text="Current Core Rewards" />
									</v-col>
									<v-col class="text-end pe-4">
										{{ $filters.currencyUSD(totalDollarCoreRewards) }}
									</v-col>
								</v-row>
								<v-row no-gutters align="start" class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-auto d-flex ga-2 pt-1 pb-2">
									<v-col cols="8" class="ga-2 d-flex flex-column ps-4">
										<LanguagePlaceholder is-html default-text="Bonus Reward" />
									</v-col>
									<v-col class="text-end pe-4">
										{{ $filters.currencyUSD(totalDollarBonusRewards) }}
									</v-col>
								</v-row>
								<v-row no-gutters align="start" class="bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-auto d-flex ga-2 pt-1 pb-0">
									<v-col cols="8" class="ga-2 d-flex flex-column ps-4">
										<LanguagePlaceholder is-html default-text="Total Qualifying Units" />
									</v-col>
									<v-col class="text-end pe-4">
										{{ myUnits }}
									</v-col>
								</v-row>
								<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
									<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('my-performance')">
										<LanguagePlaceholder default-text="View More" />
									</v-btn>  
								</div>
							</v-col>
							<v-col class="bg-color-quartz ga-2 d-flex flex-column">
								<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
									<LanguagePlaceholder default-text="Rewards Center" />
								</div>
								<v-row no-gutters align="start" class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-auto d-flex ga-2 pt-1 pb-2">
									<v-col cols="8" class="ga-2 d-flex flex-column ps-4">
										<LanguagePlaceholder is-html default-text="Total Rewards" />
									</v-col>
									<v-col class="text-end pe-4">
										{{ $filters.currencyUSD(redemptionsCredited) }}
									</v-col>
								</v-row>
								<v-row no-gutters align="start" class="divider bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-auto d-flex ga-2 pt-1 pb-2">
									<v-col cols="8" class="ga-2 d-flex flex-column ps-4">
										<LanguagePlaceholder is-html default-text="Reward Type" />
									</v-col>
									<v-col class="text-end pe-4">
										{{ redemptionsCreditedProcess }}
									</v-col>
								</v-row>
								<v-row no-gutters align="start" class="bg-color-quartz tx-color-carbon tx-font-size12 tx-font-bold w-auto d-flex ga-2 pt-1 pb-0">
									<v-col cols="8" class="ga-2 d-flex flex-column ps-4">
										<LanguagePlaceholder is-html default-text="Total Reward Balance" />
									</v-col>
									<v-col class="text-end pe-4">
										{{ $filters.currencyUSD(redemptionsBalance) }}
									</v-col>
								</v-row>

								<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
									<v-row class="d-flex justify-center">
										<v-col :cols="redemptionsCreditedProcess === 'EVoucher' && redemptionsBalance > 0 ? 6 : 12">
											<v-btn class="text-none bg-color-dell-blue" block @click="systemStore.routerTo('partner-rewards-paid')">
												<LanguagePlaceholder default-text="View More" />
											</v-btn>  
										</v-col>
										<v-col cols="6" v-if="redemptionsCreditedProcess === 'EVoucher' && redemptionsBalance > 0">														
											<v-btn 
												class="text-none bg-color-royal" 
												block 
												@click="systemStore.routerTo('redemption')">
												<LanguagePlaceholder default-text="Redeem" />
											</v-btn>  
										</v-col>
									</v-row>
								</div>
							</v-col>
						</v-row>
					</v-sheet>
					<v-sheet class="d-flex flex-column bg-color-quartz mt-auto" >
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<LanguagePlaceholder default-text="My Bonuses" />
						</div>
						<div class="flex: 1 px-2 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<v-data-table 
								density="compact"
								hide-default-footer 
								items-per-page="50" 
								:headers="headers" 
								:items="bonusData"
								item-key="id" 
								class="v-data-table-row ma-0 pa-0 w-100"
								style="min-height: 250px;"
							>
									<template v-slot:item.quarter="{ item }">
											<span>{{ currentRedemptionQuarter }}</span>
									</template>
							</v-data-table>   
						</div>
						<div class="pa-2 pt-1 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('bonus-dashboard-partner')">
								<LanguagePlaceholder default-text="View More" />
							</v-btn>    
						</div>
					</v-sheet>
				</v-col>

				<v-col class="ga-2 d-flex flex-column">
					<v-sheet class="d-flex flex-column">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<LanguagePlaceholder default-text="Rewards Calculator" />
						</div>
						<div class="px-4 pt-4 pb-2 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="Calculate how many $ rewards you could earn this incentive period based on forecast purchases." />
						</div>
						<div class="d-flex justify-center pa-2 bg-color-quartz tx-color-white">
							<v-img class="d-flex justify-center align-center" cover
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/RewardsCalculator.jpg"
							></v-img>
						</div>
						<div class="pa-2 bg-color-quartz tx-color-white tx-font-bold text-center">
							<v-btn class="text-none w-100 bg-color-dell-blue" @click="systemStore.routerTo('rewards-calculator')">
								<LanguagePlaceholder default-text="Calculate Now" />
							</v-btn>  
						</div>
					</v-sheet>
					<v-sheet class="d-flex flex-column bg-color-quartz mt-auto" style="min-height: 470px;">
						<div class="pa-2 bg-color-white tx-color-royal tx-font-bold text-center">
							<LanguagePlaceholder default-text="Help Center" />
						</div>
						<div class="px-4 pt-2 pb-1 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="<route route-name='faq' style='text-decoration: underline;'>Frequently Asked Questions</route>" />
						</div>
						<div class="px-4 pt-1 pb-1 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="<route route-name='faq' style='text-decoration: underline;'>User Guide</route>" />
						</div>
						<div class="px-4 pt-1 pb-2 bg-color-quartz tx-color-steel text-start tx-font-bold tx-font-size14">
							<LanguagePlaceholder is-html default-text="<route route-name='contact-us' style='text-decoration: underline;'>Contact Support</route>" />
						</div>
						<div class="d-flex justify-center pa-2 bg-color-quartz tx-color-white">
							<v-img class="d-flex justify-center align-center" cover 
								src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/HelpCentre.jpg"
							></v-img>
						</div>
					</v-sheet>
				</v-col>
			</v-row>
		</v-container>		
	</div>
</template>

<script setup>
import { watch, ref, computed, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import Carousel from '@/components/Carousel.vue'
import { useReportsStore } from '@/stores/reports'
import { useUserStore } from '@/stores/user'

const systemStore = useSystemStore()
const reportsStore = useReportsStore()
const userStore = useUserStore()
const carouselOneItems = ref([])

carouselOneItems.value = [    
		// {
		// 	item: 1,
		// 	url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_1.jpg',
		// 	title: '',
		// 	isClickable: true,
		// 	route: 'dncp',
		// 	customLanguageContent: undefined
		// },
		{
			item: 2,
			url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_2.jpg',
			title: '',
			isClickable: true,
			route: 'bonus-dashboard-partner',
			customLanguageContent: undefined
		},
		{
			item: 3,
			url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_3.jpg',
			title: '',
			isClickable: true,
			route: 'news',
			customLanguageContent: undefined
		},
		{
			item: 4,
			url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_4.jpg',
			title: '',
			isClickable: true,
			route: 'news',
			customLanguageContent: {
				'en': {
					imgUrl: 'https://dellpartnerincentives.com/resources/736795 Dell RISE Campaign FY26Q1 0 Financing_1300x400_EN.jpg',
					clickEvent: () => systemStore.openUrl('https://dellpartnerincentives.com/resources/FY26Q1 0 Financing_EN.pdf')
				},
				'fr': {
					imgUrl: 'https://dellpartnerincentives.com/resources/736795 Dell RISE Campaign FY26Q1 0 Financing_1300x400_FR.jpg',
					clickEvent: () => systemStore.openUrl('https://dellpartnerincentives.com/resources/FY26Q1 0 Financing_FR.pdf')
				},
				'de': {
					imgUrl: 'https://dellpartnerincentives.com/resources/736795 Dell RISE Campaign FY26Q1 0 Financing_1300x400_DE.jpg',
					clickEvent: () => systemStore.openUrl('https://dellpartnerincentives.com/resources/FY26Q1 0 Financing_DE.pdf')
				},
			},
		}
	]
 



const getImageUrl = () => {
	switch (systemStore.selectedLanguage) {
		case 'FR':
			return 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg'
		case 'DE':
			return 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2_AW.jpg'
		default:
			return 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg'
	}
}

const bonusData = ref([])
const bonusReport = ref({})
const userId = ref(0)
const headers = ref([
	{
		title: `Quarter`,
		value: `quarter`,
		headerProps: { class: 'v-data-table-header' },
		sortable: false
	},
	{
		title: `Bonus Name`,
		value: `bonusName`,
		headerProps: { class: 'v-data-table-header' },
		sortable: false
	},
	{
		title: `Bonus Value`,
		value: `bonusValue`,
		headerProps: { class: 'v-data-table-header' },
		sortable: false
	},
	{
		title: `Current Units`,
		value: `units`,
		headerProps: { class: 'v-data-table-header' },
		sortable: false
	},
	{
		title: `Threshold`,
		value: `unitThresholdAndRewardValue`,
		headerProps: { class: 'v-data-table-header' },
		sortable: false
	},
	{
		title: `Qualified`,
		value: `qualified`,
		headerProps: { class: 'v-data-table-header' },
		sortable: false
	}
])

const quarters = ref([])
const currentQuarter = ref('')
const currentRedemptionQuarter = ref('')
const myPerformanceData = ref({})
const totalDollarCoreRewards = ref(0)
const totalDollarBonusRewards = ref(0)
const myUnits = ref(0)
const redemptionSummaryData = ref({})
const redemptionsCredited = ref(0)
const redemptionsBalance = ref(0)
const redemptionsCreditedProcess = ref('')

onMounted(() => {
	
	if (systemStore.selectedLanguage === 'fr') {
		carouselOneItems.value.push({
			item: 6,
			url: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_6_FR.png',
			title: '',
			isClickable: true,
			route: 'news',
			customLanguageContent: {
				'fr': {
					imgUrl: 'https://dellpartnerincentives.com/siteassets/Images/HomePartner/HomePartnerCarousel1_6_FR.png',
					clickEvent: () => systemStore.openUrl('https://dell.zoom.us/webinar/register/WN_5_HGNGqFROiIZfH5_h1t0Q')
				}
			}
		})
	}	

	systemStore.getQuarters().then(result => {
    if (result.success) {
      quarters.value = result.quarters
      	.filter(q => q.currentQuarters === true)
      	.map(q => q.quarter)
      
			currentQuarter.value = result.quarters.find(q => q.currentQuarter === true)?.quarter

			systemStore.getMyPerformanceData(systemStore.userDetail.affinityId, currentQuarter.value).then(result => {
				myPerformanceData.value = result
				totalDollarCoreRewards.value = myPerformanceData.value.totalDollarCoreRewards
				totalDollarBonusRewards.value = myPerformanceData.value.totalDollarBonusRewards
				myUnits.value = myPerformanceData.value.csG_UnitsCountTowardThreshold_ThisPeriod + myPerformanceData.value.server_UnitsCountTowardThreshold_ThisPeriod + myPerformanceData.value.storage_UnitsCountTowardThreshold_ThisPeriod
			})

			currentRedemptionQuarter.value = result.quarters.find(q => q.currentRedemptionQuarter === true)?.quarter
			
			systemStore.getMyPerformanceData(systemStore.userDetail.affinityId, currentRedemptionQuarter.value).then(result => {
        redemptionSummaryData.value = result
			 	redemptionsCredited.value = redemptionSummaryData.value.totalDollarRewards
				redemptionsCreditedProcess.value = redemptionsCredited.value < 750 ? 'EVoucher' : 'Credit Note'

				systemStore.getRewardsAccountData(currentRedemptionQuarter.value).then(result => {
					redemptionSummaryData.value = result
					if (redemptionSummaryData.value.openingBalance > 0) {
						redemptionsBalance.value = redemptionSummaryData.value.balance
					}
					else {
						redemptionsBalance.value = redemptionsCredited.value
					}
				})
    	})

			userStore.getUserId().then(result => {
        userId.value = result.responseData  
				getBonusReportTemplate()
    	})			
		}
  })
})

const getBonusReportTemplate = () => {
    reportsStore.getReports(':BonusReport:').then(result => {
    if (result.success === true) {
        if (result.hasData) {
          bonusReport.value = JSON.parse(result.reportData)[0];
          if (bonusReport.value.Params.length > 0) {
            bonusReport.value.Params = JSON.parse(bonusReport.value.Params) 
						getReportData()
          }
       }
    }
  }).catch(error => {
      console.log(`getBonusReportTemplate`, error)
  })
}

const getReportData = () => {

    if (bonusReport.value.Params.length > 0) {
			bonusReport.value.Params.forEach((p) => {
            if (p.Name === 'Quarter') {
                p.Value = currentRedemptionQuarter.value
            }
            else if (p.Name === 'UserId') {
                p.Value = userId.value
            }
        })
    }

    bonusData.value = []

    reportsStore.getReportData(bonusReport.value, false, false).then(result => {
			if (result.success === true) {
					if (result.hasData) {
						var arr = JSON.parse(result.reportData)
						if (!arr || arr.length === 0) {
							bonusData.value = [];
						} else if (arr.length === 1) {
							bonusData.value = [arr[0]]
						} else {
							bonusData.value = arr.slice(0, 2);
						}
					}            
			}
		})
}

</script>

<style scoped>

</style>